
const INITIAL_STATE = {
  message: []
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_MESSAGES":
      return {
        ...state,
        message: action.value,
      };
    case "SEND_MESSAGES":
      return {
        ...state,
        message: action.value,
      };
    default:
      return state;
  }
};

export default reducer;
